import { FormControl, MenuItem, Select } from "@material-ui/core";
import React, { memo } from "react";
import { isUndefined } from "underscore";
import { MuiHelperText } from "../MuiHelperText";
import { ClockIcon } from "./QParkTimePicker.styledcomponents";

export type QParkTimePickerWithOptionsProps = {
  value?: string;
  onChange?: (time: string) => void;
  timeOptions: string[];
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
};

const QParkTimePickerWithOptions = memo((props: QParkTimePickerWithOptionsProps) => {
  const { value, onChange, disabled, error, helperText, timeOptions } = props;

  const handleTimeChange = (
    event: React.ChangeEvent<{
      name?: string;
      value: unknown;
    }>
  ) => {
    if (isUndefined(onChange)) {
      return;
    }

    onChange(event.target.value as string);
  };

  return (
    <FormControl variant="outlined" disabled={disabled} error={error}>
      <Select
        value={value ?? ""}
        onChange={handleTimeChange}
        displayEmpty
        IconComponent={(selectProps) => <ClockIcon {...selectProps} />}
      >
        <MenuItem value="" disabled>
          <span className="text-gray">hh:mm</span>
        </MenuItem>
        {timeOptions.map((time, index) => (
          <MenuItem key={`${time}_${index}`} value={time}>
            {time}
          </MenuItem>
        ))}
      </Select>
      <MuiHelperText error={helperText} />
    </FormControl>
  );
});

export default QParkTimePickerWithOptions;
